import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { FiSend } from "react-icons/fi";
import { GrTrash } from "react-icons/gr";
import Lottie from "react-lottie";
import { Badge, Button, Form, Input, message as AntMessage } from "antd";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { isMobile } from "react-device-detect";
import { setMicOpen } from "../../store/home/action";
import { sendText, setQuestion } from "../../store/sending/action";
import micPng from "../../assets/img/mic.png";
import * as AnimateJson from "../../assets/lottie/mic-recording.json";

const Speech = (props) => {
  const {
    onSend = () => {},
    sendLoading,
    onBlocked = () => {},
    placeholder = null,
  } = props;

  const { browserSupportsSpeechRecognition, resetTranscript, transcript } =
    useSpeechRecognition();

  const [audioStream, setAudioStream] = useState();
  const [isRecording, setIsRecording] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState("");
  const [message, setMessage] = useState("");

  const getMedia = async () => {
    if (isBlocked) return;
    if (isMobile) return;

    try {
      navigator.mediaDevices.getUserMedia =
        navigator.mediaDevices.getUserMedia ||
        navigator.mediaDevices.webkitGetUserMedia ||
        navigator.mediaDevices.mozGetUserMedia ||
        navigator.mediaDevices.msGetUserMedia;

      await navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          if (stream.active) {
            setAudioStream(stream);
          } else {
            setIsBlocked(true);
            setBlockedMessage("Please allow your microphone permission.");
            onBlocked(true, "Please allow your microphone permission.");
          }
        });
    } catch (err) {
      setIsBlocked(true);
      setBlockedMessage("Please allow your microphone permission.");
      onBlocked(true, "Please allow your microphone permission.");
      console.error(err);
    }
  };

  useEffect(() => {
    if (!browserSupportsSpeechRecognition) {
      setIsBlocked(true);
      setBlockedMessage(
        "Your browser does not support some of features! Please use chrome desktop browser for best experience."
      );
      onBlocked(
        true,
        "Your browser does not support some of features! Please use chrome desktop browser for best experience."
      );
    }
    getMedia();
    window.onblur = () => {
      SpeechRecognition.stopListening();
      setIsRecording(false);
      pauseMic();
    };
    if (transcript !== "" && isRecording) {
      setMessage(transcript);
    }
  }, [
    browserSupportsSpeechRecognition,
    isRecording,
    sendLoading,
    transcript,
    window,
  ]);

  const startRecording = () => {
    if (isBlocked) {
      AntMessage.warning(blockedMessage);
    } else {
      resetTranscript();
      setIsRecording(true);
      DetectSilence(audioStream, onSoundEnd);
      SpeechRecognition.startListening({
        // continuous: true,
        interimResults: true,
        language: "en-US",
      });
    }
  };

  const handleClearMessage = (evt) => {
    evt.preventDefault();
    resetTranscript();
    SpeechRecognition.stopListening();
    setIsRecording(false);
    setMessage("");
    pauseMic();
  };

  const handleInputFocus = (evt) => {
    evt.preventDefault();
    SpeechRecognition.stopListening();
    setIsRecording(false);
    pauseMic();
  };

  const handleSendMessage = (evt) => {
    evt.preventDefault();
    resetTranscript();
    SpeechRecognition.stopListening();
    setIsRecording(false);
    pauseMic();
    onSend(message);
    setMessage("");
  };

  const onSoundEnd = () => {
    SpeechRecognition.stopListening();
    setIsRecording(false);
    pauseMic();
  };

  const pauseMic = () => {
    audioStream?.getAudioTracks().forEach((track) => {
      track.stop();
    });
    console.log("stop audio");
  };

  const DetectSilence = (
    stream,
    onSoundEnd = () => {},
    onSoundStart = () => {},
    silence_delay = 1000,
    min_decibels = -80
  ) => {
    const ctx = new AudioContext();
    const analyser = ctx.createAnalyser();
    const streamNode = ctx.createMediaStreamSource(stream);
    streamNode.connect(analyser);
    analyser.minDecibels = min_decibels;

    const data = new Uint8Array(analyser.frequencyBinCount);
    let silence_start = performance.now();
    let triggered = false;

    const loop = (time) => {
      requestAnimationFrame(loop);
      analyser.getByteFrequencyData(data);
      if (data.some((v) => v)) {
        if (triggered) {
          triggered = false;
          onSoundStart();
        }
        silence_start = time;
      }
      if (!triggered && time - silence_start > silence_delay) {
        triggered = true;
        onSoundEnd();
        console.log("silence");
      }
    };
    loop();
  };

  let htmlBtn = (
    <Button
      htmlType={message.trim() !== "" ? "submit" : ""}
      type="primary"
      className="btn-right"
      icon={
        <Badge dot={isRecording}>
          {message.trim() !== "" ? (
            <FiSend />
          ) : (
            <>
              {isRecording ? (
                <Lottie
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: AnimateJson,
                    rendererSettings: {
                      preserveAspectRatio: "xMidYMid slice",
                    },
                  }}
                  height={20}
                  width={20}
                />
              ) : (
                <img src={micPng} alt="..." style={{ width: 20, height: 20 }} />
              )}
            </>
          )}
        </Badge>
      }
      loading={sendLoading}
      onClick={message.trim() !== "" ? handleSendMessage : startRecording}
    />
  );

  if (isBlocked || isMobile) {
    htmlBtn = (
      <Button
        htmlType="submit"
        type="primary"
        className="btn-right"
        icon={
          <Badge dot={isRecording}>
            <FiSend />
          </Badge>
        }
        loading={sendLoading}
        onClick={handleSendMessage}
      />
    );
  }

  return (
    <Form>
      <Form.Item>
        <Button
          type="primary"
          className="btn-left"
          icon={<GrTrash />}
          onClick={handleClearMessage}
        />
        <Input
          autoComplete="off"
          className="send-input-user"
          name="chatMessage"
          placeholder={placeholder}
          value={message}
          onFocus={handleInputFocus}
          onChange={(evt) => {
            resetTranscript();
            SpeechRecognition.stopListening();
            setIsRecording(false);
            pauseMic();
            setMessage(evt.target.value);
          }}
        />
        {htmlBtn}
      </Form.Item>
    </Form>
  );
};

function stateToProps(state) {
  const { home, sending } = state;
  return {
    loading: home.loading,
    micOpen: home.micOpen,
    textResponse: sending.textResponse,
  };
}

function dispatchToProps(dispatch) {
  return {
    setMicOpen: (payload) => dispatch(setMicOpen(payload)),
    sendText: (payload) => dispatch(sendText(payload)),
    setQuestion: (payload) => dispatch(setQuestion(payload)),
  };
}

export default connect(stateToProps, dispatchToProps)(Speech);
